export function isStringGuard(u: unknown): u is string {
    return typeof u === 'string';
}
